import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-chat-loading',
  templateUrl: './chat-loading.component.html',
  styleUrls: ['./chat-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatLoadingComponent {}
